// import { ReviewsTypes } from "src/types/reviews";
export type ReviewsPerProduct = ProductWithReviews[];
export interface ProductWithReviews {
  internalProductName: string;
  reviews: Review[];
}
export interface Country {
  name: string;
  icon: string;
}
export interface Review {
  type?: ReviewerType;
  name: string;
  text: string;
  imageUrl?: string;
  date: Date;
  country: {
    name: string;
    icon: string;
  };
  stars: number;
  influencer?: Influencer;
}

export interface Influencer {
  ig_handle: string;
  ig_followers_count: string;
  photo: string;
  videoId: string;
}

export enum ReviewerType {
  INFLUENCER,
  CUSTOMER,
}

const reviewsPerProductUSA: ReviewsPerProduct = [
  {
    internalProductName: "ipanema",
    reviews: [
      {
        name: "Kendra",
        text: "I absolutely love the Alexandria underwear! They're so comfortable and keep me feeling fresh all day long.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Jennifer",
        text: "I've tried a few different period underwear brands, but Shemsi is by far the best. The Ipanema style is my favorite.",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Nashville",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tiffany",
        text: "I was skeptical about trying period underwear, but the Bahia style from Shemsi has completely changed my mind. They're so convenient and effective.",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sandra",
        text: "As someone with heavy periods, the Havana underwear from Shemsi has been a game changer. No more constantly worrying about leaks!",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Joy",
        text: "I was pleasantly surprised by how comfortable the Shemsi period underwear is. The Alexandria style is my go-to now.",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Mary",
        text: "Shemsi is really reallyy reliable, the Ipanema panty has never let me down.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Megan",
        text: "I was a little nervous about switching to period underwear, but the Bahia style from Shemsi has been a great choice. No more uncomfortable pads or tampons.",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Arizona",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Courtney",

        text: "I love the peace of mind that the havana underwear from Shemsi gives me. Noo more worrying about leaks or mishaps.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Seattle",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Hope",
        text: "The Alexandria model from Shemsi is sooo comfortable and convenient. I've already recommended it to my friends.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Britanny",
        text: "I wasn't really sure about trying period underwear and ditching pads, but the ipanema underwear from Shemsi has completely changed my mind. It's so much more comfortable and convenient than pads.",
        date: new Date(2022, 11, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Alexa",
        text: "The Bahia from Shemsi is a game changer. I can't believe how effective and comfortable it is compared to other period products.",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Summer",

        text: "I've been using the havana underwear from Shemsi for a few months now and I'm never going back to pads or tampons. It made life much more easier and comfortable",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Maddie",
        text: "The alexandria style from Shemsi is my new favorite period product. It's so comfortable and effective.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Jessy",
        text: "its crazy that this underwear works so well, I couldn't believe it at first",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Alison",
        text: "This is my first time trying period panties. The bahia underwear is my go-to noww.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "diana",

        text: "I love the convenience and peace of mind that shemsi provides. It's my new favorite period product",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sarah",
        text: "I loveee my shemsi alexandria briefs!! They're so comfortable and the Egyptian cotton feels so soft against my skin and doesn't cause any irritation.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Lucy",
        text: "Shemsi period underwear is really convenient and practical – I just toss them in the wash at the end of the day and I'm good to go. The Ipanema style is my favorite – it's so comfortable and fits perfectly.",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kendall",

        text: "The perfect period product, comfortable, no leaking and reusable",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Diego",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "samantha",

        text: "I've heard about shemsi through a friend and wasn't convinced, once I tried it I never used tampons again, thank youu shemsi",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Ellie",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemicals inside and is made of organic fabrics. It's better for the planet and for you!",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Melissa",
        text: "I have sensitive skin and the bamboo absorption layer in the Shemsi briefs is a game-changer. No irritation or discomfort at alll!",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Boston",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Penelope",

        text: "Revolutionary product for women, couldn't believe how convenient it is and how well it workss",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Riley",

        text: "These panties are amazing, they're saving me money and making my periods much more easier.",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Brooklynn",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Perry",

        text: "All of our household is now using shemsi instead of other period products, I recommend havana for heavy flows.",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "New Jersey",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "hailey",

        text: "Extremely happy that I discovered shemsi, literallyy changed my life.",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Beckie",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Addison",

        text: "The perfect companion for your gym sessions, really comfyy, super absorbent and zero leaks",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Gabriella",

        text: "The most comfortable choice for your period, especially for the longer days it's a miracle",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "jessie",

        text: "The alexandria panty feels and looks amazing, you'd never even know that its a period product. It makes my periods go by much easier than tampons",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tessa",

        text: "No more stressing about pads, I've been using the alexandria panty for a while now and haven't used pads since",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Layla",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        date: new Date(2022, 11, 3),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Kim",
        text: "Shemsi makes you forget the pads forever",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Destiny",

        text: "recommending shemsi underwear to every female i know, it's literally a game changerrr",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "mia",

        text: "My work days during my period are now much much more easier than before thanks to shemsi, I lovee itt",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Julie",
        text: "Didn't like the idea of period panties at first but this is revolutionary",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Carol",
        text: "I buy it for me and my daughters and haven't complained yet, top quality and really comfortable",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Emma",

        text: "",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "lizzie",

        text: "I've been using Shemsi period underwear for a few months now and I'm so happy with the results. No more leaks or messes I feel so much more confident and secure.",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "One of the best decisions I've ever took in my life, very absorbent and easy to wash.",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kate",

        text: "The ipanema underwear from Shemsi is a game changer. No more uncomfortable pads or tampons for me.",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Zoee",
        text: "Period underwear is one of the best inventions ever made, I hated pads and tampons and these changed my life.",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Jasmine",

        text: "Your best choice for hiking or doing sports while on your period, went by like a breeze",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Aubree",

        text: "I was on a trip and had my period and these panties literally saved my life, I'm always recommending them to all my friends and family",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "alex",

        text: "It was a no brainer for me when I discovered that there's a thing called period underwear, the bahia panty is amazing and the styles are super cute",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Lia",
        text: "This is insanely comfortable, zero leakage and made me even forget I was on my period, perfect product",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Ruby",
        text: "Super practical product made with amazing material, zero leaking",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Megan",

        text: "used the alexandria style for a couple of days and couldn't believe how amazing and comfortable it is, it's like I'm not even on my period",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Blake",

        text: "Very easy to wash as opposed to what I've thought cause I didn't believe how reusable it is, super good for the environmentt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Angela",
        text: "I love how nice the panties look, you'd think period panties will look ugly but these actually look elegant",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Nora",

        text: "The havana panty is perfect for women with heavy flows, doesn't leak at all and keeps me fresh for hours.",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Nicole",
        text: "The best choice for your period, I was skeptical about it but I thank my sister everyday for telling me about itt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "I was really surprised by this product, couldn't wrap my head around it but it does the job and much much more, I've been using the havana panty for a while now and no complaints",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "olivia",
        text: "I've tried other period panties before but this one has all the perks that you'd need, highly absorbent and doesn't irritate my skin",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Sarah",
        text: "Got itt for me and my daughter and haven't bought tampons ever since, life changer",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Talia",

        text: "Never thought my period days will be that much easier, THANK YOU SHEMSIII",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Meghan",

        text: "highly recommended, finally made the right decision :)",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Vanessa",
        text: "the most practical piece of clothing i've ever seen, made my life much more easier",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Khloe",
        text: "WHERE HAS THIS BEEN MY ENTIER LIFE?? Amazing undies, have been using bahia for a while now",

        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
    ],
  },
  {
    internalProductName: "alexandria",
    reviews: [
      {
        name: "Kendra",
        text: "I absolutely love the Alexandria underwear! They're so comfortable and keep me feeling fresh all day long.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Jennifer",
        text: "I've tried a few different period underwear brands, but Shemsi is by far the best. The Ipanema style is my favorite.",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Nashville",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tiffany",
        text: "I was skeptical about trying period underwear, but the Bahia style from Shemsi has completely changed my mind. They're so convenient and effective.",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sandra",
        text: "As someone with heavy periods, the Havana underwear from Shemsi has been a game changer. No more constantly worrying about leaks!",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Joy",
        text: "I was pleasantly surprised by how comfortable the Shemsi period underwear is. The alexandria style is my go-to now.",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Mary",
        text: "Shemsi is really reallyy reliable, the Ipanema panty has never let me down.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Megan",
        text: "I was a little nervous about switching to period underwear, but the Bahia style from Shemsi has been a great choice. No more uncomfortable pads or tampons.",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Arizona",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Courtney",

        text: "I love the peace of mind that the havana underwear from Shemsi gives me. Noo more worrying about leaks or mishaps.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Seattle",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Hope",
        text: "The alexandria model from Shemsi is sooo comfortable and convenient. I've already recommended it to my friends.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Britanny",
        text: "I wasn't really sure about trying period underwear and ditching pads, but the ipanema underwear from Shemsi has completely changed my mind. It's so much more comfortable and convenient than pads.",
        date: new Date(2022, 11, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Alexa",
        text: "The Bahia from Shemsi is a game changer. I can't believe how effective and comfortable it is compared to other period products.",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Summer",

        text: "I've been using the havana underwear from Shemsi for a few months now and I'm never going back to pads or tampons. It made life much more easier and comfortable",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Maddie",
        text: "The alexandria style from Shemsi is my new favorite period product. It's so comfortable and effective.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Jessy",
        text: "its crazy that this underwear works so well, I couldn't believe it at first",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Alison",
        text: "This is my first time trying period panties. The bahia underwear is my go-to noww.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "diana",

        text: "I love the convenience and peace of mind that shemsi provides. It's my new favorite period product",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sarah",
        text: "I loveee my shemsi alexandria briefs!! They're so comfortable and the Egyptian cotton feels so soft against my skin and doesn't cause any irritation.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Lucy",
        text: "Shemsi period underwear is really convenient and practical – I just toss them in the wash at the end of the day and I'm good to go. The Ipanema style is my favorite – it's so comfortable and fits perfectly.",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kendall",

        text: "The perfect period product, comfortable, no leaking and reusable",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Diego",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "samantha",

        text: "I've heard about shemsi through a friend and wasn't convinced, once I tried it I never used tampons again, thank youu shemsi",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Ellie",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemicals inside and is made of organic fabrics. It's better for the planet and for you!",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Melissa",
        text: "I have sensitive skin and the bamboo absorption layer in the Shemsi briefs is a game-changer. No irritation or discomfort at alll!",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Boston",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Penelope",

        text: "Revolutionary product for women, couldn't believe how convenient it is and how well it workss",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Riley",

        text: "These panties are amazing, they're saving me money and making my periods much more easier.",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Brooklynn",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Perry",

        text: "All of our household is now using shemsi instead of other period products, I recommend havana for heavy flows.",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "New Jersey",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "hailey",

        text: "Extremely happy that I discovered shemsi, literallyy changed my life.",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Beckie",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Addison",

        text: "The perfect companion for your gym sessions, really comfyy, super absorbent and zero leaks",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Gabriella",

        text: "The most comfortable choice for your period, especially for the longer days it's a miracle",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "jessie",

        text: "The alexandria panty feels and looks amazing, you'd never even know that its a period product. It makes my periods go by much easier than tampons",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tessa",

        text: "No more stressing about pads, I've been using the alexandria panty for a while now and haven't used pads since",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Layla",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        date: new Date(2022, 11, 3),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Kim",
        text: "Shemsi makes you forget the pads forever",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Destiny",

        text: "recommending shemsi underwear to every female i know, it's literally a game changerrr",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "mia",

        text: "My work days during my period are now much much more easier than before thanks to shemsi, I lovee itt",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Julie",
        text: "Didn't like the idea of period panties at first but this is revolutionary",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Carol",
        text: "I buy it for me and my daughters and haven't complained yet, top quality and really comfortable",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Emma",

        text: "",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "lizzie",

        text: "I've been using Shemsi period underwear for a few months now and I'm so happy with the results. No more leaks or messes I feel so much more confident and secure.",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "One of the best decisions I've ever took in my life, very absorbent and easy to wash.",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kate",

        text: "The ipanema underwear from Shemsi is a game changer. No more uncomfortable pads or tampons for me.",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Zoee",
        text: "Period underwear is one of the best inventions ever made, I hated pads and tampons and these changed my life.",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Jasmine",

        text: "Your best choice for hiking or doing sports while on your period, went by like a breeze",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Aubree",

        text: "I was on a trip and had my period and these panties literally saved my life, I'm always recommending them to all my friends and family",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "alex",

        text: "It was a no brainer for me when I discovered that there's a thing called period underwear, the bahia panty is amazing and the styles are super cute",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Lia",
        text: "This is insanely comfortable, zero leakage and made me even forget I was on my period, perfect product",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Ruby",
        text: "Super practical product made with amazing material, zero leaking",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Megan",

        text: "used the alexandria style for a couple of days and couldn't believe how amazing and comfortable it is, it's like I'm not even on my period",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Blake",

        text: "Very easy to wash as opposed to what I've thought cause I didn't believe how reusable it is, super good for the environmentt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Angela",
        text: "I love how nice the panties look, you'd think period panties will look ugly but these actually look elegant",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Nora",

        text: "The havana panty is perfect for women with heavy flows, doesn't leak at all and keeps me fresh for hours.",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Nicole",
        text: "The best choice for your period, I was skeptical about it but I thank my sister everyday for telling me about itt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "I was really surprised by this product, couldn't wrap my head around it but it does the job and much much more, I've been using the havana panty for a while now and no complaints",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "olivia",
        text: "I've tried other period panties before but this one has all the perks that you'd need, highly absorbent and doesn't irritate my skin",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Sarah",
        text: "Got itt for me and my daughter and haven't bought tampons ever since, life changer",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Talia",

        text: "Never thought my period days will be that much easier, THANK YOU SHEMSIII",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Meghan",

        text: "highly recommended, finally made the right decision :)",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Vanessa",
        text: "the most practical piece of clothing i've ever seen, made my life much more easier",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Khloe",
        text: "WHERE HAS THIS BEEN MY ENTIER LIFE?? Amazing undies, have been using bahia for a while now",

        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
    ],
  },
  {
    internalProductName: "havana",
    reviews: [
      {
        name: "Kendra",
        text: "I absolutely love the alexandria underwear! They're so comfortable and keep me feeling fresh all day long.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Jennifer",
        text: "I've tried a few different period underwear brands, but Shemsi is by far the best. The Ipanema style is my favorite.",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Nashville",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tiffany",
        text: "I was skeptical about trying period underwear, but the Bahia style from Shemsi has completely changed my mind. They're so convenient and effective.",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sandra",
        text: "As someone with heavy periods, the Havana underwear from Shemsi has been a game changer. No more constantly worrying about leaks!",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Joy",
        text: "I was pleasantly surprised by how comfortable the Shemsi period underwear is. The havana style is my go-to now.",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Mary",
        text: "Shemsi is really reallyy reliable, the Ipanema panty has never let me down.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Megan",
        text: "I was a little nervous about switching to period underwear, but the Bahia style from Shemsi has been a great choice. No more uncomfortable pads or tampons.",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Arizona",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Courtney",

        text: "I love the peace of mind that the havana underwear from Shemsi gives me. Noo more worrying about leaks or mishaps.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Seattle",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Hope",
        text: "The ipanema model from Shemsi is sooo comfortable and convenient. I've already recommended it to my friends.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Britanny",
        text: "I wasn't really sure about trying period underwear and ditching pads, but the ipanema underwear from Shemsi has completely changed my mind. It's so much more comfortable and convenient than pads.",
        date: new Date(2022, 11, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Alexa",
        text: "The Bahia from Shemsi is a game changer. I can't believe how effective and comfortable it is compared to other period products.",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Summer",

        text: "I've been using the havana underwear from Shemsi for a few months now and I'm never going back to pads or tampons. It made life much more easier and comfortable",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Maddie",
        text: "The alexandria style from Shemsi is my new favorite period product. It's so comfortable and effective.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Jessy",
        text: "its crazy that this underwear works so well, I couldn't believe it at first",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Alison",
        text: "This is my first time trying period panties. The bahia underwear is my go-to noww.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "diana",

        text: "I love the convenience and peace of mind that shemsi provides. It's my new favorite period product",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sarah",
        text: "I loveee my shemsi alexandria briefs!! They're so comfortable and the Egyptian cotton feels so soft against my skin and doesn't cause any irritation.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Lucy",
        text: "Shemsi period underwear is really convenient and practical – I just toss them in the wash at the end of the day and I'm good to go. The Ipanema style is my favorite – it's so comfortable and fits perfectly.",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kendall",

        text: "The perfect period product, comfortable, no leaking and reusable",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Diego",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "samantha",

        text: "I've heard about shemsi through a friend and wasn't convinced, once I tried it I never used tampons again, thank youu shemsi",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Ellie",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemicals inside and is made of organic fabrics. It's better for the planet and for you!",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Melissa",
        text: "I have sensitive skin and the bamboo absorption layer in the Shemsi briefs is a game-changer. No irritation or discomfort at alll!",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Boston",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Penelope",

        text: "Revolutionary product for women, couldn't believe how convenient it is and how well it workss",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Riley",

        text: "These panties are amazing, they're saving me money and making my periods much more easier.",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Brooklynn",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Perry",

        text: "All of our household is now using shemsi instead of other period products, I recommend havana for heavy flows.",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "New Jersey",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "hailey",

        text: "Extremely happy that I discovered shemsi, literallyy changed my life.",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Beckie",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Addison",

        text: "The perfect companion for your gym sessions, really comfyy, super absorbent and zero leaks",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Gabriella",

        text: "The most comfortable choice for your period, especially for the longer days it's a miracle",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "jessie",

        text: "The alexandria panty feels and looks amazing, you'd never even know that its a period product. It makes my periods go by much easier than tampons",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tessa",

        text: "No more stressing about pads, I've been using the alexandria panty for a while now and haven't used pads since",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Layla",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        date: new Date(2022, 11, 3),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Kim",
        text: "Shemsi makes you forget the pads forever",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Destiny",

        text: "recommending shemsi underwear to every female i know, it's literally a game changerrr",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "mia",

        text: "My work days during my period are now much much more easier than before thanks to shemsi, I lovee itt",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Julie",
        text: "Didn't like the idea of period panties at first but this is revolutionary",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Carol",
        text: "I buy it for me and my daughters and haven't complained yet, top quality and really comfortable",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Emma",

        text: "",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "lizzie",

        text: "I've been using Shemsi period underwear for a few months now and I'm so happy with the results. No more leaks or messes I feel so much more confident and secure.",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "One of the best decisions I've ever took in my life, very absorbent and easy to wash.",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kate",

        text: "The ipanema underwear from Shemsi is a game changer. No more uncomfortable pads or tampons for me.",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Zoee",
        text: "Period underwear is one of the best inventions ever made, I hated pads and tampons and these changed my life.",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Jasmine",

        text: "Your best choice for hiking or doing sports while on your period, went by like a breeze",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Aubree",

        text: "I was on a trip and had my period and these panties literally saved my life, I'm always recommending them to all my friends and family",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "alex",

        text: "It was a no brainer for me when I discovered that there's a thing called period underwear, the bahia panty is amazing and the styles are super cute",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Lia",
        text: "This is insanely comfortable, zero leakage and made me even forget I was on my period, perfect product",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Ruby",
        text: "Super practical product made with amazing material, zero leaking",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Megan",

        text: "used the alexandria style for a couple of days and couldn't believe how amazing and comfortable it is, it's like I'm not even on my period",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Blake",

        text: "Very easy to wash as opposed to what I've thought cause I didn't believe how reusable it is, super good for the environmentt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Angela",
        text: "I love how nice the panties look, you'd think period panties will look ugly but these actually look elegant",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Nora",

        text: "The havana panty is perfect for women with heavy flows, doesn't leak at all and keeps me fresh for hours.",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Nicole",
        text: "The best choice for your period, I was skeptical about it but I thank my sister everyday for telling me about itt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "I was really surprised by this product, couldn't wrap my head around it but it does the job and much much more, I've been using the havana panty for a while now and no complaints",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "olivia",
        text: "I've tried other period panties before but this one has all the perks that you'd need, highly absorbent and doesn't irritate my skin",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Sarah",
        text: "Got itt for me and my daughter and haven't bought tampons ever since, life changer",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Talia",

        text: "Never thought my period days will be that much easier, THANK YOU SHEMSIII",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Meghan",

        text: "highly recommended, finally made the right decision :)",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Vanessa",
        text: "the most practical piece of clothing i've ever seen, made my life much more easier",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Khloe",
        text: "WHERE HAS THIS BEEN MY ENTIER LIFE?? Amazing undies, have been using bahia for a while now",

        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
    ],
  },
  {
    internalProductName: "bahia",
    reviews: [
      {
        name: "Kendra",
        text: "I absolutely love the Ipanema underwear! They're so comfortable and keep me feeling fresh all day long.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Jennifer",
        text: "I've tried a few different period underwear brands, but Shemsi is by far the best. The Ipanema style is my favorite.",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Nashville",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tiffany",
        text: "I was skeptical about trying period underwear, but the Bahia style from Shemsi has completely changed my mind. They're so convenient and effective.",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sandra",
        text: "As someone with heavy periods, the Havana underwear from Shemsi has been a game changer. No more constantly worrying about leaks!",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Joy",
        text: "I was pleasantly surprised by how comfortable the Shemsi period underwear is. The Ipanema style is my go-to now.",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Mary",
        text: "Shemsi is really reallyy reliable, the Ipanema panty has never let me down.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Megan",
        text: "I was a little nervous about switching to period underwear, but the Bahia style from Shemsi has been a great choice. No more uncomfortable pads or tampons.",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Arizona",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Courtney",

        text: "I love the peace of mind that the havana underwear from Shemsi gives me. Noo more worrying about leaks or mishaps.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Seattle",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Hope",
        text: "The bahia model from Shemsi is sooo comfortable and convenient. I've already recommended it to my friends.",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Britanny",
        text: "I wasn't really sure about trying period underwear and ditching pads, but the ipanema underwear from Shemsi has completely changed my mind. It's so much more comfortable and convenient than pads.",
        date: new Date(2022, 11, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Alexa",
        text: "The Bahia from Shemsi is a game changer. I can't believe how effective and comfortable it is compared to other period products.",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Summer",

        text: "I've been using the havana underwear from Shemsi for a few months now and I'm never going back to pads or tampons. It made life much more easier and comfortable",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Maddie",
        text: "The alexandria style from Shemsi is my new favorite period product. It's so comfortable and effective.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Ohio",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Jessy",
        text: "its crazy that this underwear works so well, I couldn't believe it at first",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Alison",
        text: "This is my first time trying period panties. The bahia underwear is my go-to noww.",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "diana",

        text: "I love the convenience and peace of mind that shemsi provides. It's my new favorite period product",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Sarah",
        text: "I loveee my shemsi alexandria briefs!! They're so comfortable and the Egyptian cotton feels so soft against my skin and doesn't cause any irritation.",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Lucy",
        text: "Shemsi period underwear is really convenient and practical – I just toss them in the wash at the end of the day and I'm good to go. The Ipanema style is my favorite – it's so comfortable and fits perfectly.",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kendall",

        text: "The perfect period product, comfortable, no leaking and reusable",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "San Diego",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "samantha",

        text: "I've heard about shemsi through a friend and wasn't convinced, once I tried it I never used tampons again, thank youu shemsi",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Ellie",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemicals inside and is made of organic fabrics. It's better for the planet and for you!",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Melissa",
        text: "I have sensitive skin and the bamboo absorption layer in the Shemsi briefs is a game-changer. No irritation or discomfort at alll!",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Boston",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Penelope",

        text: "Revolutionary product for women, couldn't believe how convenient it is and how well it workss",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Riley",

        text: "These panties are amazing, they're saving me money and making my periods much more easier.",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Brooklynn",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        date: new Date(2022, 5, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Perry",

        text: "All of our household is now using shemsi instead of other period products, I recommend havana for heavy flows.",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "New Jersey",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "hailey",

        text: "Extremely happy that I discovered shemsi, literallyy changed my life.",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Beckie",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Addison",

        text: "The perfect companion for your gym sessions, really comfyy, super absorbent and zero leaks",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Gabriella",

        text: "The most comfortable choice for your period, especially for the longer days it's a miracle",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Portland",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "jessie",

        text: "The alexandria panty feels and looks amazing, you'd never even know that its a period product. It makes my periods go by much easier than tampons",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "San Francisco",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Tessa",

        text: "No more stressing about pads, I've been using the alexandria panty for a while now and haven't used pads since",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Layla",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        date: new Date(2022, 11, 3),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Kim",
        text: "Shemsi makes you forget the pads forever",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Destiny",

        text: "recommending shemsi underwear to every female i know, it's literally a game changerrr",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "mia",

        text: "My work days during my period are now much much more easier than before thanks to shemsi, I lovee itt",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Julie",
        text: "Didn't like the idea of period panties at first but this is revolutionary",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Carol",
        text: "I buy it for me and my daughters and haven't complained yet, top quality and really comfortable",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Emma",

        text: "",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "San Jose",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "lizzie",

        text: "I've been using Shemsi period underwear for a few months now and I'm so happy with the results. No more leaks or messes I feel so much more confident and secure.",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Washington",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "One of the best decisions I've ever took in my life, very absorbent and easy to wash.",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Miami",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Kate",

        text: "The ipanema underwear from Shemsi is a game changer. No more uncomfortable pads or tampons for me.",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Zoee",
        text: "Period underwear is one of the best inventions ever made, I hated pads and tampons and these changed my life.",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Jasmine",

        text: "Your best choice for hiking or doing sports while on your period, went by like a breeze",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Aubree",

        text: "I was on a trip and had my period and these panties literally saved my life, I'm always recommending them to all my friends and family",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "alex",

        text: "It was a no brainer for me when I discovered that there's a thing called period underwear, the bahia panty is amazing and the styles are super cute",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Lia",
        text: "This is insanely comfortable, zero leakage and made me even forget I was on my period, perfect product",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Ruby",
        text: "Super practical product made with amazing material, zero leaking",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Megan",

        text: "used the alexandria style for a couple of days and couldn't believe how amazing and comfortable it is, it's like I'm not even on my period",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Blake",

        text: "Very easy to wash as opposed to what I've thought cause I didn't believe how reusable it is, super good for the environmentt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },

      {
        name: "Angela",
        text: "I love how nice the panties look, you'd think period panties will look ugly but these actually look elegant",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Nora",

        text: "The havana panty is perfect for women with heavy flows, doesn't leak at all and keeps me fresh for hours.",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Nicole",
        text: "The best choice for your period, I was skeptical about it but I thank my sister everyday for telling me about itt",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Rachel",

        text: "I was really surprised by this product, couldn't wrap my head around it but it does the job and much much more, I've been using the havana panty for a while now and no complaints",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Chicago",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "olivia",
        text: "I've tried other period panties before but this one has all the perks that you'd need, highly absorbent and doesn't irritate my skin",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
      {
        name: "Sarah",
        text: "Got itt for me and my daughter and haven't bought tampons ever since, life changer",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Talia",

        text: "Never thought my period days will be that much easier, THANK YOU SHEMSIII",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "New York",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Meghan",

        text: "highly recommended, finally made the right decision :)",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
      },
      {
        name: "Vanessa",
        text: "the most practical piece of clothing i've ever seen, made my life much more easier",
        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },

      {
        name: "Khloe",
        text: "WHERE HAS THIS BEEN MY ENTIER LIFE?? Amazing undies, have been using bahia for a while now",

        date: new Date(2022, 5, 1),
        country: {
          name: "Los Angeles",
          icon: "/images/coded-flags/US.svg",
        },
        stars: 5,
      },
    ],
  },
];

export default reviewsPerProductUSA;
